function isPresentMediaText(value: unknown): value is string {
  const trimmed = String(value ?? "").trim();
  return trimmed.length > 0 && trimmed !== "0";
}

/** Treat blank and literal "0" media fields as absent. */
export function readRowMediaText(
  rows: Array<Record<string, unknown>>,
  field: string,
): string | null {
  for (const row of rows) {
    const value = String(row[field] ?? "").trim();
    if (isPresentMediaText(value)) return value;
  }
  return null;
}

/** Distinct-angle arrays. Blank and literal "0" entries are dropped. */
export function readRowTextList(
  rows: Array<Record<string, unknown>>,
  field: string,
): string[] {
  const values: string[] = [];
  for (const row of rows) {
    const raw = row[field];
    const items = Array.isArray(raw) ? raw : [];
    for (const item of items) {
      const value = String(item ?? "").trim();
      if (isPresentMediaText(value)) values.push(value);
    }
  }
  return values;
}
